import { Controller } from "@hotwired/stimulus"

import { stimulus } from "../init"

export default class HeaderMenu extends Controller {
  static targets = ["button", "menu"]

  connect() {
    this.close()
  }

  toggle(event) {
    event.stopPropagation()
    this.open = !this.open
    this.sync()
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.open) return

    this.close()
    this.buttonTarget.focus()
  }

  navigate(event) {
    if (!this.open || !["ArrowDown", "ArrowUp"].includes(event.key)) return

    const items = [...this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled])')]
    if (items.length === 0) return

    event.preventDefault()
    const currentIndex = items.indexOf(document.activeElement)
    const nextIndex = currentIndex === -1
      ? (event.key === "ArrowDown" ? 0 : items.length - 1)
      : (currentIndex + (event.key === "ArrowDown" ? 1 : -1) + items.length) % items.length

    items[nextIndex].focus()
  }

  close() {
    this.open = false
    this.sync()
  }

  sync() {
    if (!this.hasButtonTarget || !this.hasMenuTarget) return

    this.buttonTarget.setAttribute("aria-expanded", String(this.open))
    this.menuTarget.dataset.open = String(this.open)
    this.menuTarget.setAttribute("aria-hidden", String(!this.open))
    this.menuTarget.inert = !this.open
  }
}

stimulus.register("header-menu", HeaderMenu)